var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScenario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52864 0.269531L18.9928 5.59313V12.0997H16.6267V7.96362L10.7116 11.3787V18.1822L11.8946 17.5168V20.233L9.52864 21.5639L0.0644531 16.2403V5.59313L9.52864 0.269531ZM2.43046 8.02828V14.8562L8.34558 18.1824V11.4434L2.43046 8.02828ZM9.52859 2.98456L3.90443 6.14717L9.47258 9.36196L15.0952 6.11578L9.52859 2.98456ZM13.0777 13.2828H22.5418V15.6488H13.0777L13.0777 13.2828ZM13.0777 16.8318H22.5418V19.1979H13.0777L13.0777 16.8318ZM13.0777 20.3809H22.5418V22.7469H13.0777L13.0777 20.3809Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario);
export default __webpack_public_path__ + "static/media/scenario.6686fd65b45b4f546290eb2a784e761c.svg";
export { ForwardRef as ReactComponent };